// extracted by mini-css-extract-plugin
export default {"component":"FriendsList_component__B9Puh","container":"FriendsList_container__lGbKO"};